import React from 'react';
import NoteBookMobile from './NoteBookMobile';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';
import NotebookImageUploader from '../NotebookImageUploader';

const MobileViews = (
    {
        step,
        inputValues,
        is_edit,
        setChildName,
        UpdateValue,
        childName,
        croppedImage,
        setCroppedImage,
        imageSelected,
        setImageSelected,
        data,
        product,
        setStep,
        setActiveOption,
        isDocumentLoading,
        activeOption,
        bookPageType,
        setBookPageType,
        setBookPageTypeArabic,
        noOfBooks,
        setNoOfBooks,
        setInputLanguage,
        productLangauges,
        setPageTypeModal,
        noOfBookOptions,
        hasImage,
        croppedFile,
        setCroppedFile
    }: {
        step: any,
        inputValues: any,
        is_edit: any,
        inputs: any,
        setChildName: any,
        UpdateValue: any,
        updateProductData: any,
        handleNextStep: any,
        childName: any,
        setNormalizeModal: any,
        croppedImage: any,
        setCroppedImage: any,
        imageSelected: any,
        setImageSelected: any,
        data: any,
        product: any,
        setStep: any,
        setActiveOption: any,
        isDocumentLoading: any,
        activeOption: any,
        bookPageType: any,
        setBookPageType: any,
        setBookPageTypeArabic: any,
        noOfBooks: any,
        setNoOfBooks: any,
        inputLanguage: any,
        setInputLanguage: any,
        productLangauges: any,
        setPageTypeModal: any,
        noOfBookOptions: any,
        hasImage: any,
        setCroppedFile:any,
        croppedFile: any
    }
) => {

  const {t} = useTranslation('personalizeModal');
  const {locale} = useRouter();

  // INSIDE PAGE OPTIONS
  const pageOptions = [
    { label: t('pageOptionsArabic'), value: 'arabic' },
    { label: t('pageOptionsMath'), value: 'mathematics' },
    { label: t('pageOptionsDrawing'), value: 'drawing' },
    { label: t('pageOptionsHebrew'), value: 'hebrew' },
    { label: t('pageOptionsEnglish'), value: 'english' },
  ];

  return (
    <div className='w-full h-full bg-transparent' dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}>
        {/* FIRST SCREEN OF PERSONALIZE MODAL: ENTER NAME AND SELECT AN IMAGE */}
        {((step === 'info' || step === 'edit') && activeOption === 'name') && (
        <div className="flex-1 overflow-y-auto space-y-6 bg-[#FFFCEB]">
          <div className='lg:mx-auto lg:max-w-xl lg:flex lg:flex-col lg:gap-6'>
            <h1 className={`text-2xl font-normal text-black ${locale === 'ar' ? 'text-right' : 'text-left'}`}>
              {t('nameModalHeading')}
            </h1>
              <div className="inputs flex flex-col gap-4 items-center mt-6 lg:mt-0">
                  {Object.entries(inputValues).map(([key, value]) => {
                    const isEmpty =
                      value === null ||
                      value === undefined ||
                      (typeof value === 'string' && value.trim() === '');

                    if (isEmpty && is_edit === '1') {
                      return null;
                    }

                    return (
                      <div key={key} className="w-full form-group">
                        <label className={`block text-xs ${locale === 'ar' ? 'text-right' : 'text-left'}`}>
                          {key === 'name' && t('inputLabels.name')}
                          {key === 'first_name' && t('inputLabels.firstName')}
                          {key === 'age' && t('inputLabels.age')}
                          {key === 'init' && t('inputLabels.init')} 
                        </label>
                        <input
                          dir={`${locale === 'ar' ? 'rtl' : 'ltr'}`}
                          type={key === 'age' ? 'number' : 'text'}
                          name={key}
                          min="1"
                          max="100"
                          onChange={e => {
                            const val = e.target.value;
                            UpdateValue(key, val);
                            if (key === 'name') setChildName(val);
                          }}
                          value={key === 'name' ? childName : inputValues[key] ?? ''}
                          className="border-1 text-primary border-gray-300 w-full font-semibold placeholder:font-light mt-2 placeholder:opacity-70 py-3 text-xs px-3 focus:ring-1 transition duration-200 focus:ring-black focus:border-transparent rounded-md"
                        />
                      </div>
                    );
                  })}
                </div>
                {hasImage && (
                  <NotebookImageUploader
                    croppedImage={croppedImage}
                    setCroppedImage={setCroppedImage}
                    imageSelected={imageSelected}
                    setImageSelected={setImageSelected}
                    isEdit={is_edit}
                    croppedFile={croppedFile}
                    setCroppedFile={setCroppedFile}
                    hasImage={hasImage}
                  />
                )}
          </div>
        </div>
        )}

        {/* REVIEW SCREEN WHERE THE BOOK IS SHOWN TO THE USER */}
        {step === 'review' && (
                <>
                  {isDocumentLoading ? (
                    <div className='flex-1 overflow-y-auto px-4 py-6 bg-[#FFFCEB] flex items-center justify-center gap-4'>
                      <div className="w-6 h-6 border-4 border-primary-500 border-t-transparent rounded-full animate-spin"></div>
                      <h2 className="text-lg font-semibold leading-none">
                        {t('bookLoadingText')}
                      </h2>
                    </div>
                  ) : (
                        <NoteBookMobile
                          pages={data?.pages?.pdf}
                          cover_pages={data?.cover_pages?.pdf}
                          cover_pages_predefined_texts={data?.cover_pages_predefined_texts}
                          product={product}
                          pages_predefined_texts={data?.pages_predefined_texts}
                          pages_dedication_texts={data?.pages_dedication_texts}
                          setActiveOption={setActiveOption}
                          childName={childName === '' ? name : childName}
                          dedicationImage={croppedImage}
                          imageSelected={imageSelected}
                          setStep={setStep}
                          bookPageType={bookPageType}
                          setPageTypeModal={setPageTypeModal}
                        />
                  )}
                </>
        )}

        {/* BOOK PAGES TYPE SELECTION SCREEN */}
        {step === 'edit' && activeOption === 'pageType' && (
          <div className='px-4 py-2 space-y-4'>
            <h2 className="text-base font-semibold text-primary text-center">
              {t('pageTypeModalHeading')}
            </h2>

            <div className="grid grid-cols-1 gap-4 mt-2">
              {pageOptions
                .filter((option) => productLangauges.includes(option.value))
                .map((option) => (
                  <div
                    key={option.value}
                    onClick={() => {
                      setBookPageType(option.value);
                      setBookPageTypeArabic(option.label);
                      setInputLanguage(option.value);
                    }}
                    className={`cursor-pointer py-3 px-4 rounded-lg border text-center text-primary bg-white text-base ${
                      bookPageType === option.value ? 'border-primary' : 'border-gray-300'
                    }`}
                  >
                    {option.label}
                  </div>
              ))}
            </div>
          </div>
        )}

        {/* NO OF BOOKS INSIDE SELECTION SCREEN */}
        {step === 'edit' && activeOption === 'noOfBooks' && (
          <div className='px-4 py-2 space-y-4'>
            <h2 className="text-base font-semibold text-primary text-center">
              {t('noOfBooksModalHeading')}
            </h2>
            <div className="grid grid-cols-2 gap-2 mt-2">
              {noOfBookOptions.map((option:any) => (
                <div
                  key={option.value}
                  onClick={() => setNoOfBooks(option.value)}
                  className={`cursor-pointer p-4 rounded-lg border text-primary bg-white ${
                    noOfBooks === option.value ? 'border-primary border-2' : 'border-gray-300'
                  } flex flex-col gap-2 items-center justify-center`}
                >
                  {/* {option.label} */}
                  <Image
                    width={100}
                    height={100}
                    src={option.image}
                    alt={option.label}
                    className='rounded-lg w-full'
                      unoptimized
                  />
                  <div className='flex items-center justify-between w-full'>
                    <h2 className='font-bold text-primary'>{option.label}</h2>
                    <p className='font-normal text-[#FF5470]'>{`₪${option.price}`}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}
    </div>
  )
}

export default MobileViews
